<template>
  <div v-if="props.type === 'image'">
    <Images @fileChosen="fileChosen"/>
  </div>
  <div v-if="props.type === 'icon'">
    <Icons @fileChosen="fileChosen" @filterCss="filterCss" />
  </div>
</template>

<script setup lang="ts">
import Images from './Images.vue'
import Icons from './Icons.vue'

const props = defineProps({
  type: String
})

const emit = defineEmits(['fileChosen', 'filterCss']);

const fileChosen = (fileUrl: string) => {

  emit('fileChosen', fileUrl)
}

const filterCss = (filter: string) => {
  emit('filterCss', filter)
}
</script>

<style scoped lang="scss">

</style>